export function addCurrentHirer(hirer) {
    return {
        type: 'ADD_CURRENT_ADMIN_HIRER',
        hirer
    }
}

export function addCurrentTrial(trial) {
    return {
        type: 'ADD_CURRENT_ADMIN_TRIAL',
        trial
    }
}

export function addCurrentProvisioning(provisioning) {
    return {
        type: 'ADD_CURRENT_ADMIN_PROVISIONING',
        provisioning
    }
}
